import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-27c08205")

_pushScopeId("data-v-27c08205")
const _hoisted_1 = { class: "workflow-array-container" }
const _hoisted_2 = { class: "workflow-title" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("New Workflow")
const _hoisted_4 = { class: "dialog-footer" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Cancel")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Save")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_button = _resolveComponent("el-button")
  const _component_WorkflowBuilder = _resolveComponent("WorkflowBuilder")
  const _component_el_dialog = _resolveComponent("el-dialog")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.workflows, (workflow, index) => {
        return (_openBlock(), _createBlock("div", {
          key: index,
          class: "workflow-array-item"
        }, [
          _createVNode("div", _hoisted_2, [
            _createVNode(_component_el_button, {
              type: "text",
              onClick: ($event: any) => (_ctx.showEditor(workflow, index))
            }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(workflow.title || 'Untitled Workflow'), 1)
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _createVNode("div", null, [
            _createVNode(_component_el_button, {
              icon: "el-icon-delete",
              circle: "",
              size: "mini",
              type: "danger",
              plain: "",
              onClick: ($event: any) => (_ctx.deleteWorkflow(index))
            }, null, 8, ["onClick"])
          ])
        ]))
      }), 128))
    ]),
    _createVNode(_component_el_button, {
      class: "new-workflow",
      type: "success",
      icon: "el-icon-plus",
      onClick: _ctx.newWorkflow
    }, {
      default: _withId(() => [
        _hoisted_3
      ]),
      _: 1
    }, 8, ["onClick"]),
    _createVNode(_component_el_dialog, {
      title: _ctx.isActiveWorkflowNew ? 'New Workflow' : 'Edit Workflow',
      onClose: _ctx.onEditorClose,
      modelValue: _ctx.isEditorVisible,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.isEditorVisible = $event))
    }, {
      footer: _withId(() => [
        _createVNode("span", _hoisted_4, [
          _createVNode(_component_el_button, { onClick: _ctx.closeEditor }, {
            default: _withId(() => [
              _hoisted_5
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _ctx.saveWorkflow
          }, {
            default: _withId(() => [
              _hoisted_6
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      default: _withId(() => [
        _createVNode(_component_WorkflowBuilder, {
          modelValue: _ctx.activeWorkflow,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.activeWorkflow = $event))
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["title", "onClose", "modelValue"])
  ], 64))
})